import React from 'react';
import type { StructuredResultItem } from '../types';
import { GenericResultItemRenderer } from './GenericResultItemRenderer';
import { BikeTrailResultItemRenderer } from './BikeTrailResultItemRenderer';
import { HikingTrailResultItemRenderer } from './HikingTrailResultItemRenderer';
import { EventResultItemRenderer } from './EventResultItemRenderer';
import { AttractionResultItemRenderer } from './AttractionResultItemRenderer';

interface ResultItemRendererFactoryProps {
  item: StructuredResultItem;
}

export const ResultItemRendererFactory: React.FC<ResultItemRendererFactoryProps> = ({ item }) => {
  switch (item.content_type) {
    case 'bike_trail':
      return <BikeTrailResultItemRenderer item={item} />;
    case 'hiking_trail':
      return <HikingTrailResultItemRenderer item={item} />;
    case 'event':
      return <EventResultItemRenderer item={item} />;
    case 'attraction':
      return <AttractionResultItemRenderer item={item} />;
    default:
      return <GenericResultItemRenderer item={item} />;
  }
};
